import React, { lazy, Suspense } from "react";
import { createFromIconfontCN, HomeFilled } from "@ant-design/icons";
import Login from "@/pages/Login"; //登录
import PageNotFound from "@/pages/PageNotFound";
import TrainTask from "@/pages/admin/Train/TrainCenter/trainTask";
import ExamTask from "@/pages/admin/Train/ExamCenter/examTask";
import CreateQuestion from "@/pages/admin/Train/QuestionBankManagement/createQuestion";
import PreviewQuestion from "@/pages/admin/Train/QuestionBankManagement/previewQuestion";

const IconFont = createFromIconfontCN({
  scriptUrl: [process.env.REACT_APP_ICON],
});

const Home = lazy(() => import("@/pages/admin/home"));
const DataSet = lazy(() => import("@/pages/admin/DataSet"));
const DatasetDetail = lazy(() => import("@/pages/admin/DataSet/detail"));
const Train = lazy(() => import("@/pages/admin"));
const QuestionBankManagement = lazy(() => import("@/pages/admin/Train/QuestionBankManagement"));
const StatisticsCenter = lazy(() => import("@/pages/admin/Train/StatisticsCenter"));
const QuestionBankList = lazy(() => import("@/pages/admin/Train/QuestionBankManagement/list"));
const QuestionBankListTTS = lazy(() => import("@/pages/admin/Train/QuestionBankManagement/listTTS"));
const QuestionBankDetail = lazy(() => import("@/pages/admin/Train/QuestionBankManagement/detail"));
// const CreateQuestion = lazy(() => import("@/pages/admin/Train/QuestionBankManagement/createQuestion"));
// const PreviewQuestion = lazy(() => import("@/pages/admin/Train/QuestionBankManagement/previewQuestion"));
const ExamCenter = lazy(() => import("@/pages/admin/Train/ExamCenter"));
const TrainCenter = lazy(() => import("@/pages/admin/Train/TrainCenter"));
const TrainCenterStatus = lazy(() => import("@/pages/admin/Train/TrainCenter/list"));
const ExamCenterStatus = lazy(() => import("@/pages/admin/Train/ExamCenter/list"));
const TrainTaskDetail = lazy(() => import("@/pages/admin/Train/TrainCenter/detail"));
const ExamTaskDetail = lazy(() => import("@/pages/admin/Train/ExamCenter/detail"));
const AddTrainTask = lazy(() => import("@/pages/admin/Train/TrainCenter/add"));
const EditTrainTask = lazy(() => import("@/pages/admin/Train/TrainCenter/edit"));
const AddExamTask = lazy(() => import("@/pages/admin/Train/ExamCenter/add"));
const EditExamTask = lazy(() => import("@/pages/admin/Train/ExamCenter/edit"));
// const TrainTask = lazy(() => import("@/pages/admin/Train/TrainCenter/task"));
const AptitudeManagement = lazy(() => import("@/pages/admin/Train/AptitudeManagement"));
const Supplier = lazy(() => import("@/pages/admin/supplier"));
const SupplierList = lazy(() => import("@/pages/admin/supplier/list"));
const PMList = lazy(() => import("@/pages/admin/PMManage/PMList"));
const InspectorList = lazy(() => import("@/pages/admin/inspector/list")); // 验收员管理
const InspectorCreate = lazy(() => import("@/pages/admin/inspector/create")); // 验收员管理
const ProjectManagement = lazy(() => import("@/pages/admin/projectManagement")); // 项目管理
const SettleManagement = lazy(() => import("@/pages/admin/settleManagement")); // 结算管理
const SettleDetail = lazy(() => import("@/pages/admin/settleManagement/detail")); // 结算管理详情
const InquirySheet = lazy(() => import("@/pages/admin/inquirySheet")); // 询价单管理
const InquirySheetDetail = lazy(() =>
  import("@/pages/admin/inquirySheet/detail")
); // 询价单管理详情
const InquiryApproveSheetDetail = lazy(() =>
  import("@/pages/admin/inquirySheet/approveDetail")
); // 询价单管理详情
const TerminalMan = lazy(() => import("@/pages/admin/terminalMan")); // 用户管理
const FeedBack = lazy(() => import("@/pages/admin/feedBack")); // 问题反馈
const PersonalCenter = lazy(() => import("@/pages/admin/personalCenter")); // 个人中心
const TeamRecruitment = lazy(() => import("@/pages/admin/teamRecruitment")); // 团队招募列表

export const mainRoutes = [
  {
    path: "/login",
    // path: token == null ? "/login" : "/admin/home",
    component: Login,
    title: "Login_62c726fe-de03-2864-be71-cbf35ce30098",
    key: "login",
  },
  {
    path: "/404",
    component: PageNotFound,
    title: "404",
    isExt: false,
  },
  {
    title: "e54ec4e5-1054-2271-97cb-5d9cf88ea5b6",
    path: "/trainTask/:id/:status",
    component: TrainTask, //培训任务
    key: "cultivateRepoManage",
  },
  {
    title: "e54ec4e5-1054-2271-97cb-5d9cf88ea5b6",
    path: "/examTask/:id/:status",
    component: ExamTask, //考试任务
    key: "examinationRepoManage",
  },
  {
    title: "88119f41-1f77-2134-89a7-c8f98038c592",
    path: "/createQuestion/:id/:productionId",
    component: CreateQuestion, //创建传统题目
    key: "questionRepoManage",
  },
  {
    title: "43d28447-da41-24b3-9545-8a9e6d871a0d",
    path: "/previewQuestion",
    component: PreviewQuestion, //预览题目
    showInMenu: false,
    key: "questionRepoManage",
  },
];

export const adminRoutes = [
  {
    title: "Homepage_90f32925-9e3c-22f6-8f36-962def8afb31",
    icon: <IconFont type="icon-shouye" />,
    path: "/admin/home",
    component: Home, //前端组件
    showInMenu: true,
    key: "home",
    index: 1,
  },
  {
    title: "35aecf78-3aa5-2415-9fdb-49e29c1a19f6",
    path: "/admin/train/questionManage/list/:productionId",
    component: QuestionBankList, //题库列表
    showInMenu: false,
    exact: true,
    key: "questionRepoManage",
    index: 23,
  },
  {
    title: "35aecf78-3aa5-2415-9fdb-49e29c1a19f6",
    path: "/admin/train/questionManage/listTTS/:productionId",
    component: QuestionBankListTTS, //题库列表 TTS
    showInMenu: false,
    exact: true,
    key: "questionRepoManage",
    index: 23,
  },
  {
    title: "97d89a45-fb5a-2579-a083-3fc0bed3884e",
    path: "/admin/train/questionManage/list/detail/:id/:name/:productionId",
    component: QuestionBankDetail, //题库详情
    showInMenu: false,
    key: "questionRepoManage",
    index: 24,
  },
  {
    title: "e999869f-00b6-2576-8bfd-37fda7aada09",
    path: "/admin/train/trainCenter/detail/:id/:name",
    component: TrainTaskDetail, //培训任务详情
    showInMenu: false,
    key: "cultivateRepoManage",
    index: 25,
  },
  {
    title: "e999869f-00b6-2576-8bfd-37fda7aada09",
    path: "/admin/train/examCenter/detail/:id/:name",
    component: ExamTaskDetail, //考试任务详情
    showInMenu: false,
    key: "examinationRepoManage",
    index: 26,
  },
  {
    title: "fdc38416-391b-2092-b081-daab86b37830",
    path: "/admin/train/trainCenter/addTrainTask",
    component: AddTrainTask, //新建培训任务
    showInMenu: false,
    key: "cultivateRepoManage",
    index: 27,
  },
  {
    title: "43aeb4ae-aca4-2297-9746-48fc716c685c",
    path: "/admin/train/trainCenter/editTrainTask/:id",
    component: EditTrainTask, //编辑培训任务
    showInMenu: false,
    key: "cultivateRepoManage",
    index: 28,
  },
  {
    title: "d4b0ae1c-5426-2b74-a9c0-34520979aa73",
    path: "/admin/train/examCenter/addExamTask",
    component: AddExamTask, //新建考试任务
    showInMenu: false,
    key: "examinationRepoManage",
    index: 29,
  },
  {
    title: "7e51b491-261d-255a-be41-6e2f5eb00275",
    path: "/admin/train/examCenter/editExamTask/:id",
    component: EditExamTask, //编辑考试任务
    showInMenu: false,
    key: "examinationRepoManage",
    index: 30,
  },
  {
    title: "e0cd252d-c5fa-2ebf-bef9-c705b31730b7",
    icon: <IconFont type="icon-kaoshi" />,
    path: "/admin/train",
    component: Train, //前端组件
    showInMenu: true,
    key: "examManage",
    index: 2,
    children: [
      {
        title: "Statistics_Center",
        path: "/admin/train/statisticsCenter",
        component: StatisticsCenter, //统计中心
        showInMenu: true,
        key: "examStatistics",
        index: 31,
      },
      {
        title: "88119f41-1f77-2134-89a7-c8f98038c592",
        path: "/admin/train/questionManage",
        component: QuestionBankManagement, //题库管理
        showInMenu: true,
        key: "questionRepoManage",
        index: 17,
      },
      {
        title: "ea8fd16b-5b51-25f0-9618-b2efe291d64e",
        path: "/admin/train/examCenter",
        component: ExamCenter, //考试中心
        showInMenu: true,
        key: "examinationRepoManage",
        index: 18,
      },
      {
        title: "ea8fd16b-5b51-25f0-9618-b2efe291d64e",
        path: "/admin/train/examineeExamCenter",
        component: ExamCenterStatus, //考生考试中心
        showInMenu: true,
        key: "examineeExaminationRepoManage",
        index: 19,
      },
      {
        title: "39da9cba-e7f0-21d1-93ea-9f52dc679533",
        path: "/admin/train/trainCenter",
        component: TrainCenter, //考官培训中心
        showInMenu: true,
        key: "cultivateRepoManage",
        index: 20,
      },
      {
        title: "39da9cba-e7f0-21d1-93ea-9f52dc679533",
        path: "/admin/train/examineeTrainCenter",
        component: TrainCenterStatus, //考生培训中心
        showInMenu: true,
        key: "examineeCultivateRepoManage",
        index: 21,
      },
      {
        title: "6e0b2f6b-f8a4-2428-a0d7-234c5b67d709",
        path: "/admin/train/aptitudeManage",
        component: AptitudeManagement, //资质管理
        showInMenu: true,
        key: "aptitudeManage",
        index: 22,
      }
    ],
  },
  {
    title: "supplier_management_6aa66577-824c-21e1-b18a-f10478dc9dc9",
    icon: <IconFont type="icon-gongyingshangguanli" />,
    path: "/admin/teamManage",
    component: SupplierList, //前端组件
    showInMenu: true,
    key: "teamManage",
    index: 3,
  },
  {
    title: "Supplier_Homepage_192c9db2-076f-26ee-8099-2e70ecf51b36",
    icon: <HomeFilled />,
    path: "/admin/teamHome",
    component: Supplier, //前端组件
    showInMenu: true,
    key: "teamHome",
    index: 4,
  },
  {
    title: "315d3af8-7da3-2250-9c26-34cdaea5d7b6",
    icon: <IconFont type="icon-project" />,
    path: "/admin/teamRecruitment",
    component: TeamRecruitment, // 团队招募
    exact: true, //路由是否全匹配
    showInMenu: true,
    key: "teamRecruitment",
  },
  {
    title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/inquiryManage",
    component: InquirySheet, //前端组件
    exact: true, //路由是否全匹配
    showInMenu: true,
    key: "quotationManage",
    index: 5,
  },
  {
    title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/inquiryManage/detail",
    component: InquirySheetDetail, //前端组件
    key: "quotationManage",
    index: 6,
  },
  {
    title: "Inquiry_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/inquiryManage/approveDetail",
    component: InquiryApproveSheetDetail, //前端组件
    key: "quotationManage",
    index: 7,
  },
  {
    title: "Project_Management_fd8b706f-45dc-2c4a-8b0e-0577a75de6fa",
    icon: <IconFont type="icon-xiangmuguanli1" />,
    path: "/admin/projectManage",
    component: ProjectManagement, //前端组件
    showInMenu: true,
    key: "projectManage",
    index: 8,
  },
  {
    title: "Settle_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/settleManagement",
    component: SettleManagement, //前端组件
    exact: true, //路由是否全匹配
    showInMenu: true,
    key: "settlementManage",//settleManage
    index: 9,
  },
  {
    title: "Settle_Management_5645c7b3-b2ce-2f57-9d29-795227dbd39d",
    icon: <IconFont type="icon-biaoqian2" />,
    path: "/admin/settleManagement/detail",
    component: SettleDetail, //前端组件
    key: "settlementManage",
    index: 10,
  },
  {
    title: "Worker_Management_d308ca5d-8799-289e-8a59-dc6c3292e7ea",
    icon: <IconFont type="icon-ziyuan174" />,
    path: "/admin/userManage",
    component: TerminalMan, //前端组件
    showInMenu: true,
    key: "userManage",
    index: 11,
  },
  {
    title: "PM_Management_31b5f5cd-78b4-2bf0-82a8-1f992a890871",
    icon: <IconFont type="icon-project" />,
    path: "/admin/PMManage",
    component: PMList, // 内部管理
    showInMenu: true,
    key: "PMManage",
    index: 12,
  },
  {
    title: "Inspector_Management_b0322bf7-3c40-24a9-88f5-fec65a44901c",
    icon: <HomeFilled />,
    path: "/admin/inspector/list",
    component: InspectorList, //前端组件
    showInMenu: true,
    key: "companyManage1",
    index: 13,
  },
  {
    title: "Inspector_Management_b0322bf7-3c40-24a9-88f5-fec65a44901c",
    icon: <HomeFilled />,
    path: "/admin/inspector/create",
    component: InspectorCreate, //前端组件
    showInMenu: false,
    key: "companyManage1",
    index: 14,
  },
  {
    title: "Account_Center_9253f02a-772f-2d9c-a902-6afed7c36c9e",
    icon: <IconFont type="icon-shezhi" />,
    path: "/admin/personalCenter", ///:id
    component: PersonalCenter, //前端组件
    showInMenu: true,
    key: "personalCenter",
    index: 15,
  },
  {
    title: "Report_Issue_b531f551-9d61-2f83-9863-edd3d66a96cc",
    icon: <IconFont type="icon-menu_fkgl" />,
    path: "/admin/feedback", ///:id
    component: FeedBack, //前端组件
    showInMenu: true,
    key: "feedback",
    index: 16,
  }
];